const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateEmail(email: string): string | null {
  if (!email.trim()) return 'Συμπλήρωσε το email σου.';
  if (!EMAIL_RE.test(email.trim())) return 'Μη έγκυρη διεύθυνση email.';
  return null;
}

export function validatePassword(password: string): string | null {
  if (!password) return 'Συμπλήρωσε κωδικό.';
  if (password.length < 6) return 'Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.';
  return null;
}
